<div class="container m-auto flex flex-col justify-center items-center h-screen">
  <h1>Ooops!</h1>
  <div>
    <p>You don't have access to this page</p>
  </div>
</div>
